// extracted by mini-css-extract-plugin
export default {"trigger":"BpsActionMenu_trigger__ur0bj","menu":"BpsActionMenu_menu__dE3Yr","item":"BpsActionMenu_item__8BXc-","danger":"BpsActionMenu_danger__EOtMu"};